<template>
  <v-dialog v-model="opened" max-width="290" persistent>
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>
        {{ subtitle }}
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="grey darken-1" text :disabled="loading" @click="close()">
          <v-icon small left>mdi-close</v-icon>
          Batal
        </v-btn>

        <v-btn
          color="red darken-1"
          text
          :disabled="loading"
          :loading="loading"
          @click="deleteAction()"
        >
          <v-icon small left>mdi-delete</v-icon>
          Verifikasi
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import ApiService from "@/core/services/api.service";

export default {
  data() {
    return {
      opened: false,
      loading: false,
      id: null
    };
  },
  props: {
    url: {
      type: String
    },
    title: {
      type: String,
      default: "Apakah anda yakin?"
    },
    subtitle: {
      type: String,
      default:
        "Apakah anda yakin ingin memverifikasi data ini?"
      //Do you really want to delete this records? This process cannot be undone
    },
    success: {
      type: Function,
      default: function() {}
    }
  },
  methods: {
    open(id) {
      if (typeof id == "undefined" || id === null) {
        return;
      }
      this.opened = true;
      this.id = id;
    },
    deleteAction() {
      if (!this.url) {
        this.success(this.id);
        this.opened = false;
        this.id = null;
        return;
      }
      this.loading = true;

      ApiService.delete(this.url + "?id=" + this.id)
        .then(({ data }) => {
          if (data.deleted > 0) {
            this.opened = false;
            this.loading = false;
            this.$swal.fire({
              icon: "success",
              title: "Berhasil",
              text: "Data berhasil dihapus",
              showConfirmButton: false,
              timer: 3000
            });
            this.success(data);
          }
        })
        .catch(({ response }) => {
          this.loading = false;
          if (response) {
            this.handleError(response);
          }
        });
    },
    close() {
      this.opened = false;
      this.id = null;
    },
    handleError(response) {
      if (response.data.error) {
        this.$swal.fire({
          icon: "warning",
          text: response.data.error,
          title: response.statusText,
          showConfirmButton: false,
          timer: 3000
        });
      }

      if (response.data.errors && response.data.errors.length > 0) {
        response.data.errors.forEach(err => {
          this.$swal.fire({
            icon: "warning",
            title: response.data.status,
            text: err.msg || err,
            showConfirmButton: false,
            timer: 3000
          });
        });
      }
    }
  }
};
</script>

<style></style>
